import { Container, Flex, Link, Text } from '@chakra-ui/react';
import { Counter, Divider, Visible } from 'components';
import { ReactNode, useState } from 'react';

type TravelersFilterProps = {
    onChange: (values: any) => void;
};

const TRAVELERS_OPTIONS = [
    {label: 'Adults', subtitle: '14 years or older'},
    {label: 'Children', subtitle: 'From 12 to 1 years '},
    {label: 'Babies', subtitle: 'Less than 1 year'},
    {label: 'Pets', subtitle: <Link>Assistance pet?</Link>}
];

const travelerTile = (
    label: string,
    subtitle: string | ReactNode,
    onChange: (label: string, value: number | string) => void,
    index: number
) => {
    return <Flex direction="column" paddingTop="10px" key={label}>
            <Flex direction="row" justifyContent="space-between" paddingBottom="20px">
                <Flex direction="column">
                    <Text fontFamily="Montserrat" fontWeight={600} fontSize={15}>{label}</Text>
                    <Text color="#A3A3A3" fontFamily="Montserrat" fontWeight={400} fontSize={13}>{subtitle}</Text>
                </Flex>
                <Counter onChange={(value) => onChange(label, value)} />
            </Flex>
            <Visible when={index + 1 !== TRAVELERS_OPTIONS.length}>
               <Divider />
            </Visible>
        </Flex>
};

const TravelersFilter = ({onChange}: TravelersFilterProps) => {
    const [travelers, setTravelers] = useState({});

    const onTravelersChange = (name: string, value: string | number) => {
        setTravelers({...travelers, [name]: value});
        onChange(travelers);
    };

    return <Container padding={10} width={500}>
       {TRAVELERS_OPTIONS.map((option, index) =>
            travelerTile(option.label, option.subtitle, onTravelersChange, index)
        )}
    </Container>
}

export {TravelersFilter};